import { i18nMark } from 'lingui-react';

export const pageTitles = {
  casePage: i18nMark('ONCall - Case {caseNumber}'),
  casePrintPage: i18nMark('ONCall - Print Case {caseNumber}'),
  dashboard: i18nMark('ONCall - Dashboard'),
  highlightedCases: i18nMark('ONCall - Cases Needing Validation'),
  dealerLocator: i18nMark('ONCall - Service Provider Locator'),
  techAdminDealerList: i18nMark('ONCall - Tech Admin - Service Providers'),
  techAdminDealerPage: i18nMark('ONCall - Tech Admin'),
  techAdminDealerSearch: i18nMark('ONCall - Tech Admin - Search'),
  reports: i18nMark('ONCall - Reports - {reportType}'),
};

export const pageMeta = {
  casePage: i18nMark('Case Detail'),
  casePrintPage: i18nMark('Print Case'),
  dashboard: i18nMark('Dashboard'),
  highlightedCases: i18nMark('Cases Needing Validation'),
  dealerLocator: i18nMark('Service Provider Locator'),
  techAdminDealerList: i18nMark('TechAdmin Service Providers'),
  techAdminDealerPage: i18nMark('TechAdmin Service Provider Detail'),
  techAdminDealerSearch: i18nMark('TechAdmin Service Provider Search'),
  reports: i18nMark('Reports'),
};



// WEBPACK FOOTER //
// ./src/pages/constants.js